import { GWMarketDataSummaryBucket } from '../../models/gateway/types';
import { GatewayRequestType } from '../web-socket/types';

export interface BaseSubscriptionRequestType {
    messageType: GatewayRequestType,
    traceIdentifier: string,
    token?: string,
}

export interface SymbolSubscriptionRequestType extends BaseSubscriptionRequestType {
    symbols: string[]
}

export interface SymbolBucketSubscriptionRequestType extends SymbolSubscriptionRequestType {
    bucket: GWMarketDataSummaryBucket
}

export interface SymbolInstrumentSnapshotSubscriptionRequestType extends SymbolSubscriptionRequestType {
    includePreMarket: boolean,
    includePostMarket: boolean,
}

export interface NewsSubscriptionRequestType extends BaseSubscriptionRequestType {
    pageSize: number,
    pageNumber: number,
}

export interface SymbolNewsSubscriptionRequestType extends NewsSubscriptionRequestType {
    symbols: string// this is not an array in BE!
}

export type SocketRequestType =
    BaseSubscriptionRequestType
    | SymbolSubscriptionRequestType
    | SymbolBucketSubscriptionRequestType
    | NewsSubscriptionRequestType
    | SymbolInstrumentSnapshotSubscriptionRequestType
    | SymbolNewsSubscriptionRequestType;

export interface FxResponseType {
    fixTime: number, // index=0
    bidPrice: number, // index=1
    bidSize: number, // index=2
    askPrice: number, // index=3
    askSize: number, // index=4
}

export enum CurrencySymbolType {
    EuroUSDollar = 'EURUSD',
    USDollarTurkishLira = 'USDTRY',
    USDollarBulgarianLev = 'USDBGN',
}

export enum ExtendedCurrencySymbolType {
    EuroUSDollar = 'EUR/USD',
    USDollarTurkishLira = 'USD/TRY',
    USDollarBulgarianLev = 'USD/BGN',
}
